import { render, staticRenderFns } from "./treatrecord.vue?vue&type=template&id=23fb08ca"
import script from "./treatrecord.vue?vue&type=script&lang=js"
export * from "./treatrecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('23fb08ca')) {
      api.createRecord('23fb08ca', component.options)
    } else {
      api.reload('23fb08ca', component.options)
    }
    module.hot.accept("./treatrecord.vue?vue&type=template&id=23fb08ca", function () {
      api.rerender('23fb08ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/therapy/treatrecord.vue"
export default component.exports